import { apsByActivityCategoryInitialState } from './reducer'

const getApsByActivityCategoryStateByAppId = (state, appId) =>
  state.activityProvider.apsByActivityCategory[appId] || apsByActivityCategoryInitialState

export default {
  getApsByActivityCategoryStateByAppId
}
